// extracted by mini-css-extract-plugin
export default {"panel":"EditDetailsPanel_panel__rVXqW","controls":"EditDetailsPanel_controls__GW44R"};